import { combineEpics } from 'redux-observable'

import { createInvokeEpic } from '../../signalr/createInvokeEpic'
import { createStreamEpic } from '../../signalr/createStreamEpic'

import {
  checkoutTicketDefinition,
  confirmTradeDefinition,
  fetchTradeBlotterDefinition,
  uncheckoutTicketDefinition
} from './definition'

export default combineEpics(
  createStreamEpic('tradeBlotter.fetch', fetchTradeBlotterDefinition),
  createInvokeEpic('tradeBlotter.confirmTrade', confirmTradeDefinition),
  createInvokeEpic('tradeBlotter.checkoutTicket', checkoutTicketDefinition),
  createInvokeEpic('tradeBlotter.uncheckoutTicket', uncheckoutTicketDefinition)
)
